/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetEstimationAndTrendWebModel,
  IGetEstimationAndTrendWebRequest,
  IMappers,
  IGetEstimationAndTrendWebResponse,
  IGetEstimationAndTrendWebResponseError,
  TGetEstimationAndTrendWebResponse,
} from './types';

const defaultConfig: TGetEstimationAndTrendWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v1/get-estimation-and-trend-web/',
  hostType: 'api',
} as TGetEstimationAndTrendWebModel;

function createGetEstimationAndTrendWebModel(
  parameters: IGetEstimationAndTrendWebRequest,
): TGetEstimationAndTrendWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetEstimationAndTrendWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetEstimationAndTrendWebRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetEstimationAndTrendWeb<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetEstimationAndTrendWebOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetEstimationAndTrendWebResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetEstimationAndTrendWebModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetEstimationAndTrendWebResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetEstimationAndTrendWebResponseError);
    }
  }

  return { response, statusCode } as TGetEstimationAndTrendWebResponse;
}

export { defaultConfig, createGetEstimationAndTrendWebModel, fetchGetEstimationAndTrendWeb };
